// Module
var code = "<react-component name=\"BulkCancelMemberships\"></react-component>\n";
// Exports
module.exports = code;